export const animations = {
  gamepad1: require("../assets/animations/bg_gamepad1.json"),
  gamepad2: require("../assets/animations/bg_gamepad2.json"),
  portal: require("../assets/animations/effect-portal.json"),
  fight: require("../assets/animations/effect-fight.json"),
  fire: require("../assets/animations/bg_top-fire.json"),
  astroplayroom: require("../assets/animations/Astroplayroom.json"),
  bloodborne: require("../assets/animations/BloodBorne.json"),
  concretegenie: require("../assets/animations/ConcreteGenie.json"),
  darksouls: require("../assets/animations/DarkSouls.json"),
  daysgone: require("../assets/animations/DaysGone.json"),
  allstars: require("../assets/animations/DestructionAllStars.json"),
  gg: require("../assets/animations/GG.json"),
  ghostoftsusima: require("../assets/animations/GhostOfTsusima.json"),
  godofwar: require("../assets/animations/GodOfWar.json"),
  littlebigplanet: require("../assets/animations/LittleBigPlanet.json"),
  ratchetclanc: require("../assets/animations/RatchetClanc.json"),
  uncharted: require("../assets/animations/Uncharted.json"),
  untildawn: require("../assets/animations/UntillDawn.json"),
  thelastofus: require("../assets/animations/TheLastOfUs.json")
};

export default function getAnimation(name) {
  return animations[name] || "";
}
